import { getApiUrl } from "src/environment";

import { getYachtId } from "./localStorage";

export type CrumbOptions = {
  /** When true, record for every yacht — not only the approve list. */
  allYachts?: boolean;
};

/**
 * Crumb logging function to track data for debugging purposes.
 * By default only logs for approved yacht IDs to reduce spam.
 * Pass `{ allYachts: true }` for events that must be recorded fleet-wide.
 *
 * @param message - A descriptive message about what is being logged
 * @param data - Optional data object to be logged (will be JSON stringified)
 * @param options - Optional flags (e.g. allYachts)
 */
export function crumb(
  message: string,
  data?: any,
  options?: CrumbOptions,
): void {
  try {
    const approve: Record<string, boolean> = {
      "a810afbe-3e95-5729-1e8d-1bb8306fd3f0": true,
      "70d7cf3e-271c-11ef-aaf9-02c1fe2db5a5": true,
      "792fa17e-3bd4-11f0-8651-02c1fe2db5a5": true,
    };

    const yachtId = getYachtId();
    if (!yachtId) return;
    if (!options?.allYachts && !approve[yachtId]) return;

    fetch(getApiUrl(), {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request: "crumb",
        params: {
          message,
          data: data ? JSON.stringify(data) : null,
          yachtId,
          timestamp: new Date().toISOString(),
        },
      }),
    })
      .then(res => res.json())
      .then(res => {
        console.debug("Crumb logged successfully", res);
      })
      .catch(error => {
        console.debug("Crumb logging failed", error);
      });
  } catch (error) {
    console.debug("Crumb function error", error);
  }
}
